const VERSION = "v0.3.0";
const ABOUT_TEXT = `「空を感じる」${VERSION}。写真と気象モデルを照らし合わせ、身近な自然現象を観察し、自分の空のアルバムとして見返せます。星空指数・お月見指数が見れるようになりました。`;

function installVersionStyle(): void {
  const style = document.createElement("style");
  style.textContent = `
    .home-version {
      margin: 18px 0 2px;
      color: #8ba0a6;
      font-size: .66rem;
      font-weight: 600;
      letter-spacing: .06em;
      text-align: center;
    }
  `;
  document.head.appendChild(style);
}

function ensureHomeVersion(): void {
  const home = document.querySelector<HTMLElement>(".page--home");
  if (!home || home.querySelector(".home-version")) return;

  const version = document.createElement("p");
  version.className = "home-version";
  version.textContent = VERSION;
  home.appendChild(version);
}

function ensureAboutVersion(): void {
  const heading = Array.from(document.querySelectorAll<HTMLElement>(".settings-card h2")).find(
    (element) => element.textContent?.trim() === "このアプリについて",
  );
  const paragraph = heading?.closest<HTMLElement>(".settings-card")?.querySelector<HTMLParagraphElement>("p");
  if (!paragraph || paragraph.textContent === ABOUT_TEXT) return;
  paragraph.textContent = ABOUT_TEXT;
}

function ensureVersionLabels(): void {
  ensureHomeVersion();
  ensureAboutVersion();
}

installVersionStyle();
new MutationObserver(ensureVersionLabels).observe(document.documentElement, { childList: true, subtree: true });
queueMicrotask(ensureVersionLabels);
